import CheckPermission from 'components/auth/CheckPermission'
import Permissions from 'types/Permissions.generated'

import { UnificacaoBaseBox } from './UnificacaoBaseBox'

export const UnificacaoBaseView = () => {
  return (
    <CheckPermission permission={Permissions.configuracaoDeInstalacao.configurarConexaoComInternet}>
      <UnificacaoBaseBox />
    </CheckPermission>
  )
}
